import { render, staticRenderFns } from "./CompetitionsList.vue?vue&type=template&id=02b691fb&"
import script from "./CompetitionsList.vue?vue&type=script&lang=js&"
export * from "./CompetitionsList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports